
import React from "react"
import { Modal, Button } from "react-bootstrap"
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom"
import { formatDate } from "../../../../../utils/dateUtils"
import { useState } from "react"
import { useDispatch } from "react-redux";
import { stopPatientPrescriptionAction } from "../../../../../store/actions/PrescriptionAction";
import { getPatientPrescriptionsAction } from "../../../../../store/actions/PrescriptionAction"
import { handleSuccess, showErrorAlert } from "../../../../../services/ErrorHandlingService";

const PrescriptionHistoryModal = ({ show, onHide, prescriptionData, rawPrescriptions,handleViewClick,handleEditClick, patientDetails }) => {
  // Debug: Log the prescription data when modal opens
  const [confirmStop, setConfirmStop] = useState(null);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (show && prescriptionData) {
     

      prescriptionData.forEach((prescription, index) => {
        console.log(`Prescription ${index}:`, prescription)
        if (prescription.medicines && prescription.medicines.length > 0) {
          prescription.medicines.forEach((med, medIndex) => {
            console.log(`  Medicine ${medIndex}:`, {
              medicine_id: med.medicine_id,
              medicine_name: med.medicine_name,
              full_object: med,
            })
          })
        }
      })
    }
  }, [show, prescriptionData])

  const handleViewClickWithDebug = (prescription) => {
    if (prescription.medicines && prescription.medicines.length > 0) {
      prescription.medicines.forEach((med, index) => {
        console.log(`Medicine ${index} being passed:`, {
          medicine_id: med.medicine_id,
          medicine_name: med.medicine_name,
          full_object: med,
        })
      })
    }
    console.log("SELECTED PRESCRIPTION:", prescription)

    handleViewClick(prescription)
  }

  const handleEditPrescription = (prescription) => {
    console.log("EDIT PRESCRIPTION:", prescription);
  
    handleEditClick(prescription); // 🔥 CORRECT FUNCTION
  
    onHide();
  };
  const calculateSuggestedDiscount = (prescription) => {
    const subtotal =
      parseFloat(prescription?.items_subtotal ?? 0) || 0;
  
    // ✅ use medicine started date
    const startedDateRaw =
      prescription?.medicine_started_date;
  
    // ✅ if no medicine started date
    if (
      !startedDateRaw ||
      startedDateRaw === "0000-00-00"
    ) {
      // return full subtotal directly
      return subtotal;
    }
  
    const startedDate = new Date(startedDateRaw);
    const today = new Date();
  
    const diffMs =
      today.getTime() - startedDate.getTime();
  
    const elapsedDays = Math.max(
      0,
      Math.floor(diffMs / (1000 * 60 * 60 * 24))
    );
  
    const durationMonths =
      parseFloat(prescription?.duration ?? 0) || 0;
  
    const totalDays = durationMonths * 30;
  
    // safety
    if (totalDays <= 0) {
      return subtotal;
    }
  
    const remainingDays = Math.max(
      0,
      totalDays - elapsedDays
    );
  
    // proportional remaining amount
    const discount =
      subtotal * (remainingDays / totalDays);
  
    return Number(discount.toFixed(2));
  };

  return (
    <>
    <Modal show={show} 
    onHide={onHide} 
    centered size="lg"
       style={{ zIndex:10 }}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Prescription History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card shadow-none">
          <div className="card-body">
            {prescriptionData.length > 0 ? (  
              prescriptionData.map((prescription, index) => (
<div
  className="mb-4 timeline-panel flex-wrap border-0 p-3 rounded position-relative"
  key={index}
  style={{
    backgroundColor: prescription.status === "Pending" ? "rgba(255, 255, 0, 0.3)" : "white",
    boxShadow: prescription.status !== "Pending" ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
  }}
>
{prescription.is_stop === "Yes" && (
  <span
    className="badge bg-danger"
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      padding: "6px 10px",
      fontSize: "12px",
      borderRadius: "20px",
    }}
  >
    Stopped
  </span>
)}
{prescription.mark_as_complete === "Yes" && (
  <span
    className="badge bg-success"
    style={{
      position: "absolute",
      top: "10px",
      right: prescription.is_stop === "Yes" ? "95px" : "10px",
      padding: "6px 10px",
      fontSize: "12px",
      borderRadius: "20px",
      zIndex: 2,
    }}
  >
    Completed
  </span>
)}
                  <p className="fs-15 mb-0">
                    <strong>Prescribed By:</strong> {prescription.prescribed_by}
                  </p>
                  <p className="fs-15 mb-0">
                    {/* <strong>Date:</strong> {formatDate(prescription.created_at)} */}
                    <strong>Date:</strong> {formatDate(prescription.date)}
                  </p>
                  {/* <p className="fs-15 mb-0">
                    <strong>Diseases:</strong> {prescription.diseases || "None"}
                  </p> */}
                  <p className="fs-15 mb-0">
                    <strong>Status:</strong> {prescription.status || "-"}
                  </p>

               

                  <div className="d-flex justify-content-start mt-3">
                    <Link
                      to="#"
                      className="btn btn-primary btn-sm me-2"
                      onClick={() => handleViewClickWithDebug(prescription)}
                    >
                      View
                    </Link>
     

{/* INFO ICON FOR STOPPED + PAID */}
{String(prescription?.is_stop || "")
  .toLowerCase()
  .trim() === "yes" &&
  String(
    prescription?.prescription_payment_status || ""
  )
    .toLowerCase()
    .trim() === "paid" && (

    <OverlayTrigger
      placement="right"
      trigger={["hover", "focus"]}
      overlay={
        <Tooltip
          id={`tooltip-${
            prescription.prescriptionId ||
            prescription.prescription_id ||
            index
          }`}
          className="custom-tooltip"
        >
          <style>
            {`
              .custom-tooltip .tooltip-inner {
                background: transparent !important;
                padding: 0 !important;
                border: none !important;
                max-width: none !important;
                color: transparent !important;
              }

              .custom-tooltip .tooltip-arrow::before {
                display: none !important;
              }

              .custom-tooltip.show {
                opacity: 1 !important;
              }

              .custom-tooltip {
                background: transparent !important;
              }
            `}
          </style>

          <div
  style={{
    textAlign: "left",
    minWidth: "260px",
    padding: "12px",

    background:
      "rgba(255, 255, 255, 0.78)",

    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",

    border:
      "1px solid rgba(255,255,255,0.25)",

    color: "#333333",
    borderRadius: "14px",

    boxShadow:
      "0 6px 18px rgba(0,0,0,0.14)",

    fontFamily: "Arial, sans-serif",
  }}
>

  {/* HEADER */}
  <div
    style={{
      borderBottom:
        "1px solid rgba(0,0,0,0.06)",

      paddingBottom: "8px",
      marginBottom: "10px",
    }}
  >
    <div
      style={{
        fontSize: "14px",
        fontWeight: "700",
        color: "#dc3545",

        display: "flex",
        alignItems: "center",

        gap: "6px",
      }}
    >
      <i
        className="fa fa-ban"
        style={{
          fontSize: "11px",
        }}
      ></i>

      <span>
        Stopped Prescription
      </span>
    </div>
  </div>
  {prescription?.medicine_started_date &&
 prescription.medicine_started_date !== "0000-00-00" && (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "8px",
      fontSize: "13px",
    }}
  >
    <span
      style={{
        color: "#6b7280",
        fontWeight: "500",
      }}
    >
      Medicine Started
    </span>

    <span
      style={{
        color: "#111827",
        fontWeight: "600",
      }}
    >
      {new Date(
        prescription.medicine_started_date
      )
        .toLocaleDateString("en-GB")
        .replace(/\//g, "-")}
    </span>
  </div>
)}
  {/* STOPPED DATE */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      marginBottom: "8px",

      fontSize: "13px",
    }}
  >
    <span
      style={{
        color: "#6b7280",
        fontWeight: "500",
      }}
    >
      Stopped Date
    </span>

    <span
      style={{
        color: "#111827",
        fontWeight: "600",
      }}
    >
      {prescription?.stopped_date
        ? formatDate(
            prescription.stopped_date
          )
        : "-"}
    </span>
  </div>

  {/* PRESCRIPTION AMOUNT */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      marginBottom: "8px",

      fontSize: "13px",
    }}
  >
    <span
      style={{
        color: "#6b7280",
        fontWeight: "500",
      }}
    >
      Prescription Amount
    </span>

    <span
      style={{
        color: "#198754",
        fontWeight: "700",
      }}
    >
      ₹{" "}
      {Number(
        prescription?.items_subtotal || 0
      ).toFixed(2)}
    </span>
  </div>

  {/* DISCOUNT BOX */}
  <div
    style={{
      background:
        "rgba(248,250,252,0.72)",

      backdropFilter: "blur(8px)",
      WebkitBackdropFilter:
        "blur(8px)",

      borderRadius: "10px",

      padding: "10px",

      border:
        "1px solid rgba(255,255,255,0.2)",

      marginTop: "6px",
    }}
  >

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <span
        style={{
          color: "#6b7280",
          fontSize: "13px",
        }}
      >
        Suggested Discount
      </span>

      <span
        style={{
          color: "#2563eb",
          fontWeight: "700",
          fontSize: "14px",
        }}
      >
        ₹{" "}
        {calculateSuggestedDiscount(
          prescription
        ).toFixed(2)}
      </span>
    </div>

  </div>

</div>
        </Tooltip>
      }
    >
      <div
        className=" d-inline-flex align-items-center justify-content-center"
        style={{
          width: "36px",
          height: "36px",
          minWidth: "36px",
          minHeight: "36px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background:
            "rgba(255,255,255,0.55)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter:
            "blur(10px)",
          cursor: "pointer",
          border:
            "1px solid rgba(255,255,255,0.35)",
          boxShadow:
            "0 2px 10px rgba(0,0,0,0.08)",
          padding: 0,
          margin: 0,
          lineHeight: 1,
        }}

      >
        <i
          className="fa fa-info-circle"
          style={{
            color: "#dc3545",
            fontSize: "14px",
            display: "block",
            margin: 0,
            padding: 0,
            lineHeight: 1,
            transform: "translateX(0.5px)",
          }}
        ></i>
      </div>
    </OverlayTrigger>
)}

                    {prescription.is_stop !== "Yes" && 
 prescription.mark_as_complete !== "Yes" &&
 prescription.status !== "DELIVERED" &&  (
                      <>
                    
                          <span className="ms-2 d-inline-block">
                            <Button
                              variant="warning"
                              size="sm"
                              onClick={() => handleEditPrescription(prescription)}
                            >
                              Edit
                            </Button>
                          </span>
                       
                       
                          <Button
                            variant="danger"
                            size="sm"
                            className="ms-2"
                            onClick={() => setConfirmStop(prescription)}
                          >
                            Stop Prescription
                          </Button>
                     
                      </>
                    )}
</div>

                </div>
              ))
            ) : (
              <div className="text-center text-muted">No prescription history found</div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
    <Modal show={!!confirmStop} centered onHide={() => setConfirmStop(null)}>
        <Modal.Header closeButton>
          <Modal.Title>Stop Prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop this ongoing prescription?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmStop(null)}>
            No
          </Button>
          <Button
  variant="danger"
  onClick={async () => {
    console.log("confirmStop object:", confirmStop);

    const prescriptionId =
    confirmStop?.prescription_id || confirmStop?.prescriptionId;
  
  const patientId =
    confirmStop?.patient_id || confirmStop?.patientId;
  
  if (!prescriptionId) {
    showErrorAlert("Prescription ID missing");
    return;
  }
  
  const result = await dispatch(
    stopPatientPrescriptionAction(prescriptionId)
  );
  
  if (result?.success) {
    handleSuccess("Prescription stopped successfully");
  
    await dispatch(
      getPatientPrescriptionsAction({
        patient_id: patientId 
      })
    );
  
    setConfirmStop(null);
  }
  }}
>
  Yes, Stop
</Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PrescriptionHistoryModal;


// import React from "react"
// import { Modal, Button } from "react-bootstrap"
// import { Link } from "react-router-dom"
// import { formatDate } from "../../../../../utils/dateUtils"

// const PrescriptionHistoryModal = ({ show, onHide, prescriptionData, handleViewClick }) => {
  
//   const [localData, setLocalData] = React.useState([]);
//   const [confirmStop, setConfirmStop] = React.useState(null);

//   // Load incoming prescriptionData into local state
//   React.useEffect(() => {
//     if (show && Array.isArray(prescriptionData)) {
//       setLocalData([...prescriptionData]);
//     }
//   }, [show, prescriptionData]);

//   const handleViewClickWithDebug = (prescription) => {
//     handleViewClick(prescription)
//   };

//   // STOP PRESCRIPTION - Local only
//   const stopPrescription = () => {
//     if (!confirmStop) return;

//     const updated = localData.map((item) =>
//       item._id === confirmStop._id
//         ? { ...item, status: "Stopped" }
//         : item
//     );

//     setLocalData(updated);
//     setConfirmStop(null);
//   };

//   return (
//     <>
//       {/* Main Modal */}
//       <Modal show={show} onHide={onHide} centered size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Prescription History</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="card shadow-none">
//             <div className="card-body">
//               {localData.length > 0 ? (
//                 localData.map((prescription, index) => (
//                   <div
//                     className="mb-4 timeline-panel flex-wrap border-0 p-3 rounded"
//                     key={index}
//                     style={{
//                       backgroundColor: prescription.status === "Pending"
//                         ? "rgba(255, 255, 0, 0.3)"
//                         : "white",
//                       boxShadow: prescription.status !== "Pending"
//                         ? "0 4px 8px rgba(0, 0, 0, 0.2)"
//                         : "none",
//                     }}
//                   >
//                     <p className="fs-15 mb-0"><strong>Prescribed By:</strong> {prescription.prescribed_by}</p>
//                     <p className="fs-15 mb-0"><strong>Date:</strong> {formatDate(prescription.date)}</p>
//                     <p className="fs-15 mb-0"><strong>Status:</strong> {prescription.status || "-"}</p>

//                     <div className="d-flex gap-2 mt-3">
//                       {/* VIEW BUTTON */}
//                       <Link
//                         to="#"
//                         className="btn btn-primary btn-sm"
//                         onClick={() => handleViewClickWithDebug(prescription)}
//                       >
//                         View
//                       </Link>

//                       {/* STOP BUTTON - only if Active/Ongoing */}
//                       {(prescription.status === "Active" ||
//                         prescription.status === "Ongoing") && (
//                         <Button
//                           variant="danger"
//                           size="sm"
//                           onClick={() => setConfirmStop(prescription)}
//                         >
//                           Stop Prescription
//                         </Button>
//                       )}
//                     </div>
//                   </div>
//                 ))
//               ) : (
//                 <div className="text-center text-muted">No prescription history found</div>
//               )}
//             </div>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button onClick={onHide}>Close</Button>
//         </Modal.Footer>
//       </Modal>

//       {/* CONFIRM STOP MODAL */}
//       <Modal show={!!confirmStop} centered onHide={() => setConfirmStop(null)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Stop Prescription</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           Are you sure you want to stop this ongoing prescription?
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConfirmStop(null)}>
//             Cancel
//           </Button>
//           <Button variant="danger" onClick={stopPrescription}>
//             Yes, Stop
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default PrescriptionHistoryModal;
